export const DEFAULT_FILE_SIZE_LIMIT = 314_572_800; // 300 MB

export const allowedClientMIMETypes: { [key: string]: string } = {
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export const ALLOWED_TYPES: { [key: string]: string } = {
  docx: '.docx',
};
